export const ERROR_PAGE_ROUTE = '/error';
export const REFERRAL_DASHBOARD_ROUTE = '/referral-dashboard';
export const DEVELOPER_DASHBOARD_ROUTE = '/developer';
export const SIGN_UP_ROUTE = '/sign-up';
export const SUBSCRIPTION_PREFERENCES_ROUTE = '/subscription-preferences';
export const WELCOME_LEAD_ROUTE = '/welcome';
export const WELCOME_REDIRECT_ROUTE = '/welcome-redirect';
